import React from 'react'

export default function Theader(props) {
    return (
        <th className='table-border h-primary'>{props.header}</th>
    )
}
